module.exports = __webpack_public_path__ + "3b20db880c867d057ab0798628a005f0.svg";